import { useState, useCallback } from "react"
import Link from "next/link"
import Arrow from "public/assets/pawprint-arrow.svg"
import useWindowSize from "utilities/useWindowSize"
import getStoryblokLink from "utilities/getStoryblokLink"
import richText from "utilities/richText"

export function Column({ title, top_cell_main, top_cell_caption, bottom_cell }) {
  return (
    <div className="min-w-[200px] grid grid-rows-[1fr,2fr,2fr] bg-white last:border-l-2 first:border-r-2 border-gray-light items-center">
      <h3 className="bg-green-apple text-black text-m1 uppercase py-3 flex items-center justify-center">{title}</h3>
      <div className="py-4 border-b-4 border-gray-light">
        <div className="text-l2 text-center font-bold">{top_cell_main}</div>
        <div className="text-center uppercase text-s1 font-medium">{top_cell_caption}</div>
      </div>
      <div className="text-l2 text-center font-bold leading-none">{bottom_cell}</div>
    </div>
  )
}

export default function ContentWith2ColumnChart({ blok }) {
  const { width } = useWindowSize()
  const visibleSlides = useCallback(() => {
    if (width >= 640) return 2
    return 1
  }, [width])

  const lastIndex = blok.columns?.length - 1
  const [currentSlide, setSlide] = useState(0)

  const prevSlide = () => setSlide(currentSlide === 0 ? lastIndex : currentSlide - 1)

  const nextSlide = () => setSlide(currentSlide === lastIndex ? 0 : currentSlide + 1)

  return (
    <section className="bg-gray-light py-12 px-8 relative">
      <div className="max-w-screen-xl mx-auto lg:flex items-center">
        <div className="prose-h2:text-green-pine prose-h2:pb-4 prose-p:pb-3 lg:max-w-3xl pr-8">
          {richText(blok.content)}
        </div>
        <div className="ml-auto mr-0 items-center max-w-5xl z-10 mt-4 lg:mt-0">
          <div className="overflow-hidden max-w-[200px] sm:max-w-[400px] mx-auto shadow-lg">
            <div
              className="flex transition-transform duration-700"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              aria-live="off"
            >
              {blok.columns.map((column, idx) => (
                <Column {...column} key={idx} />
              ))}
            </div>
          </div>
          <Link
            href={getStoryblokLink(blok.download_link)}
            className="text-green table mx-auto lg:float-right font-bold pt-2 text-green-pine underline hover:no-underline"
          >
            Download full pricing menu
          </Link>
          {visibleSlides() < 2 ? (
            <div>
              <button onClick={prevSlide} aria-label="Previous Slide">
                <Arrow className="carousel-arrow absolute left-0 bottom-44 rotate-180 scale-75" />
              </button>
              <button onClick={nextSlide} aria-label="Next Slide">
                <Arrow className="carousel-arrow absolute right-0 bottom-44 scale-75" />
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}
